import * as TooltipPrimitive from "@radix-ui/react-tooltip";
import React, { forwardRef } from "react";

import { cn } from "../cn";

export const TooltipProvider = TooltipPrimitive.Provider;
export const Tooltip = TooltipPrimitive.Root;
export const TooltipTrigger = TooltipPrimitive.Trigger;

export const TooltipContent = forwardRef<React.ElementRef<typeof TooltipPrimitive.Content>, React.ComponentPropsWithoutRef<typeof TooltipPrimitive.Content>>(function TooltipContent(
  { className, sideOffset = 4, collisionPadding = 8, children, ...props },
  ref,
) {
  return (
    <TooltipPrimitive.Portal>
      <TooltipPrimitive.Content
        ref={ref}
        data-redesign-v1
        sideOffset={sideOffset}
        collisionPadding={collisionPadding}
        className={cn(
          "tw-z-50 tw-max-w-xs tw-overflow-hidden tw-text-balance tw-rounded-md tw-border tw-border-solid tw-border-border",
          "tw-bg-card tw-px-3 tw-py-1.5 tw-font-sans tw-text-xs tw-text-card-foreground tw-shadow-md",
          className,
        )}
        {...props}
      >
        {children}
      </TooltipPrimitive.Content>
    </TooltipPrimitive.Portal>
  );
});
